
export default function SocialIssues() {
  return (
    <section id="social-issues" className="py-16 md:py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-block px-5 py-2 bg-teal-50 border border-teal-200 rounded-full mb-4">
            <span className="text-teal-600 text-xs md:text-sm font-bold uppercase tracking-wider">Social Issues</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 mb-4 md:mb-6">
            Social Issues We Address
          </h2>
          <p className="text-sm md:text-lg text-gray-600 max-w-3xl mx-auto font-medium leading-relaxed">
            ROBO Asset Grid tackles critical challenges in energy management and sustainability
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-12 md:mb-16">
          {/* Card 1 */}
          <div className="bg-white rounded-xl p-5 md:p-6 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-gradient-to-br from-red-500 to-orange-500 rounded-lg mb-3 md:mb-4">
              <i className="ri-fire-line text-2xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-base md:text-xl font-bold text-gray-900 mb-2">
              Energy Crisis
            </h3>
            <p className="text-sm md:text-base text-gray-600 leading-relaxed font-medium">
              Rising energy costs and supply instability threaten economic stability and quality of life
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-xl p-5 md:p-6 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-gradient-to-br from-green-500 to-emerald-500 rounded-lg mb-3 md:mb-4">
              <i className="ri-leaf-line text-2xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-base md:text-xl font-bold text-gray-900 mb-2">
              Climate Change
            </h3>
            <p className="text-sm md:text-base text-gray-600 leading-relaxed font-medium">
              Urgent need to reduce carbon emissions and transition to sustainable energy sources
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-xl p-5 md:p-6 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 rounded-lg mb-3 md:mb-4">
              <i className="ri-water-flash-line text-2xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-base md:text-xl font-bold text-gray-900 mb-2">
              Water Infrastructure
            </h3>
            <p className="text-sm md:text-base text-gray-600 leading-relaxed font-medium">
              Aging water systems waste enormous amounts of untapped kinetic energy daily
            </p>
          </div>

          {/* Card 4 */}
          <div className="bg-white rounded-xl p-5 md:p-6 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-gradient-to-br from-orange-500 to-amber-500 rounded-lg mb-3 md:mb-4">
              <i className="ri-funds-line text-2xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-base md:text-xl font-bold text-gray-900 mb-2">
              Resource Efficiency
            </h3>
            <p className="text-sm md:text-base text-gray-600 leading-relaxed font-medium">
              Need for innovative solutions to maximize energy recovery from existing infrastructure
            </p>
          </div>
        </div>

        {/* Smart Digital Prepaid Water Meter */}
        <div className="mb-12 md:mb-16">
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl md:rounded-3xl p-6 md:p-9 lg:p-11 border border-gray-200 shadow-lg">
            <div className="flex items-center gap-3 md:gap-4 mb-6 md:mb-8">
              <div className="w-12 md:w-14 h-12 md:h-14 bg-teal-600 rounded-xl flex items-center justify-center">
                <i className="ri-water-flash-line text-2xl md:text-3xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl md:text-3xl font-black text-gray-900">Smart Digital Prepaid Water Meter</h3>
                <p className="text-gray-600 text-sm md:text-base mt-1 font-semibold">스마트디지털 선불형 수도계량기</p>
              </div>
            </div>

            {/* Product Display Images */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-xl border border-gray-100 mb-6">
              <div className="w-full h-[280px] sm:h-[380px] md:h-[500px] flex items-center justify-center bg-gray-50 p-2 sm:p-4">
                <img
                  src="https://static.readdy.ai/image/2299103fa86076f2ed06076e2d6cbff8/ba7c8b8e8311fdbbc063802084478f45.png"
                  alt="Digital Water Meter Product Display"
                  title="ROBO Asset Grid Digital Water Meter Product Lineup"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>

            <div className="bg-white rounded-2xl overflow-hidden shadow-xl border border-gray-100">
              <div className="w-full h-[280px] sm:h-[380px] md:h-[500px] flex items-center justify-center bg-gray-50 p-2 sm:p-4">
                <img
                  src="https://static.readdy.ai/image/2299103fa86076f2ed06076e2d6cbff8/0ca813b0f3dfb2c032ae3008e7e79eff.png"
                  alt="Smart Digital Prepaid Water Meter"
                  title="ROBO Asset Grid Smart Digital Prepaid Water Meter Product"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>

            <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
              <div className="bg-teal-50 rounded-xl p-3 md:p-4 text-center flex flex-col items-center justify-center">
                <i className="ri-bank-card-line text-4xl md:text-5xl text-teal-600 mb-2"></i>
                <p className="text-base md:text-lg font-bold text-gray-800">Prepaid System</p>
              </div>
              <div className="bg-teal-50 rounded-xl p-3 md:p-4 text-center flex flex-col items-center justify-center">
                <i className="ri-smartphone-line text-4xl md:text-5xl text-teal-600 mb-2"></i>
                <p className="text-base md:text-lg font-bold text-gray-800">Mobile Connected</p>
              </div>
              <div className="bg-teal-50 rounded-xl p-3 md:p-4 text-center flex flex-col items-center justify-center">
                <i className="ri-shield-check-line text-4xl md:text-5xl text-teal-600 mb-2"></i>
                <p className="text-base md:text-lg font-bold text-gray-800">Fraud Prevention</p>
              </div>
              <div className="bg-teal-50 rounded-xl p-3 md:p-4 text-center flex flex-col items-center justify-center">
                <i className="ri-line-chart-line text-4xl md:text-5xl text-teal-600 mb-2"></i>
                <p className="text-base md:text-lg font-bold text-gray-800">Real-time Monitoring</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
